import { type PropsWithChildren, useMemo } from 'react'
import { useAppSelector } from '../../Common/_hooks/useAppSelector'
import BaseProductSearchBar, { type ProductSearchFilterOption } from './BaseProductSearchBar'
import { type ItemListSearchParams } from '../../Common/ItemList/ItemList'
import { type ProductSortType } from '../../UserData/_stores/UserPrefsStore'

export interface ProductSearchParams extends ItemListSearchParams {
  categories: string[]
  search: string[]
  collections: string[]
  sort: ProductSortType[]
}

type Props = PropsWithChildren<{
  placeholder?: string
  value?: ProductSearchParams
  onChange?: (value: (value: ProductSearchParams) => ProductSearchParams) => void
}>

export default function ProductSearchBar(props: Props) {
  const viewCategories = useAppSelector(state => state.get('appData').get('viewCategories'))

  const options = useMemo(() => {
    const options: ProductSearchFilterOption[] = []

    viewCategories
      .filter(category => category.get('id_parent') === null)
      .forEach(category => {
        // Main category
        options.push({
          id: category.get('id'),
          label: category.get('name'),
          emphasized: true,
        })

        // Skip subcategories for fabric
        // TODO: Would be nice to find a cleaner way to do this instead of hardcoding
        if (category.get('slug') === 'fabrics') {
          return
        }

        // Subcategories
        viewCategories
          .filter(subCategory => subCategory.get('id_parent') === category.get('id'))
          .forEach(subCategory => {
            options.push({
              id: subCategory.get('id'),
              label: subCategory.get('name'),
              imageSlug: subCategory.get('slug'),
            })
          })
      })

    return options
  }, [viewCategories])

  return <BaseProductSearchBar
    placeholder={props.placeholder}
    value={props.value}
    onChange={props.onChange}
    filterField="categories"
    filterOptions={options}
  >
    {props.children}
  </BaseProductSearchBar>
}
